module.exports = __webpack_public_path__ + "img/banner5.7f71a02f.png";